// @flow
import styled from 'styled-components';

export const PrimaryButton = styled.input`
  border: none;
  outline: none;
  color: white;
  background-color: ${props => props.theme.V3.colors.primary.normal};
  border-radius: ${props => props.theme.V3.metrics.borderRadius}px;
  
  :hover {
      background-color: ${props => props.theme.V3.colors.primary.light};
  }
`;

export const SecondaryButton = styled.button`
  border-color: ${props => props.theme.V3.colors.primary.normal};
  border-radius: ${props => props.theme.V3.metrics.borderRadius}px;
  color: ${props => props.theme.V3.colors.primary.normal};
  outline: none;
  
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  :hover {
    background-color: ${props => props.theme.V3.colors.form.fill};
  }
`;



// WEBPACK FOOTER //
// ./src/statsradio/components/ui/forms/ButtonInput.js